import { render, staticRenderFns } from "./BuildingListFilters.vue?vue&type=template&id=5e508153&"
import script from "./BuildingListFilters.vue?vue&type=script&lang=js&"
export * from "./BuildingListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports